import { SECONDS_TO_MILLIS } from "lopermut"
import { DoorOpen } from "lucide-react"
import { toast } from "sonner"

type Props = {
  title: string
  description: string
}

export function Notification({ title, description }: Props) {
  toast.custom(
    () => (
      <div className="border border-gradient-shiny rounded-md shadow-lg overflow-hidden min-w-[320px] max-w-[400px]">
        <div className="flex items-center gap-2 px-3 py-2 border-b border-border bg-sidebar dark:bg-sidebar-accent text-sidebar-foreground text-sm">
          <DoorOpen size={16} />
          <span className="font-semibold tracking-wide flex-1">{title}</span>
        </div>
        <div className="bg-sidebar-accent dark:bg-sidebar px-3 py-2 text-muted-foreground text-base leading-snug">
          {description}
        </div>
      </div>
    ),
    {
      duration: 8 * SECONDS_TO_MILLIS,
      position: "top-right",
    },
  )
}
